import Button from "../common/Button";
import BaseModal from "./BaseModal";

export default function OutboundCallModal({
  open,
  form,
  busy,
  onChange,
  onSubmit,
  onClose,
}) {
  return (
    <BaseModal
      open={open}
      onClose={busy ? () => {} : onClose}
      title="Call Client"
      meta="Start an outbound call from Calling AI to a patient."
      modalId="outboundModal"
    >
      <form className="outbound-form" onSubmit={onSubmit}>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="obPhone">
            Phone Number
          </label>
          <input
            className="outbound-input"
            id="obPhone"
            name="phone"
            type="tel"
            placeholder="+971501234567"
            value={form.phone}
            onChange={(event) => onChange("phone", event.target.value)}
            required
            disabled={busy}
            readOnly
          />
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="obName">
            Patient Name
          </label>
          <input
            className="outbound-input"
            id="obName"
            name="patient_name"
            type="text"
            placeholder="Patient name"
            value={form.name}
            onChange={(event) => onChange("name", event.target.value)}
            required
            disabled={busy}
            readOnly
          />
        </div>
        <div className="outbound-field">
          <label className="outbound-label" htmlFor="obReason">
            Reason
          </label>
          <input
            className="outbound-input"
            id="obReason"
            name="reason"
            type="text"
            placeholder="appointment reminder"
            value={form.reason}
            onChange={(event) => onChange("reason", event.target.value)}
            disabled={busy}
            readOnly
          />
        </div>
        {form.summary ? (
          <div className="modal-summary-block">
            <div className="modal-summary-label">Lead Summary</div>
            <div className="modal-summary-text">{form.summary}</div>
          </div>
        ) : null}
        <div className="outbound-help">
          Use full international format (+971501234567) or local format
          (0501234567).
        </div>
        <div className="outbound-actions">
          <Button onClick={onClose} disabled={busy}>
            Cancel
          </Button>
          <Button type="submit" variant="green" disabled={busy}>
            {busy ? "Calling..." : "Start Call"}
          </Button>
        </div>
      </form>
    </BaseModal>
  );
}
